import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  subTotalRow: {
    display: 'flex',
    marginBottom: theme.spacing(1)
  } as SxProps,

  subtotalTitleText: {
    textAlign: 'left',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: '14px'
    }
  } as SxProps,

  mobileRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    width: '100%'
  } as SxProps,

  mobileLeftContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0
  } as SxProps,

  accordionWrapper: {
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      '& .MuiAccordionSummary-content': {
        flexGrow: 0
      }
    }
  } as SxProps,

  mobileButtonWrapper: {
    flexShrink: 0,
    paddingTop: '23px'
  } as SxProps,

  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      gap: theme.spacing(2)
    }
  } as SxProps,

  fieldText: {
    color: theme.palette.grey[500],
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  },

  totalText: {
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(2.5)
    }
  },

  totalValueText: {
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: '16px',
      color: theme.palette.blue[800],
      textAlign: 'left',
      marginTop: theme.spacing(0.25)
    }
  } as SxProps,

  packageStatsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    paddingBottom: theme.spacing(1)
  } as SxProps,

  packageStatRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  } as SxProps,

  packageStatLabel: {
    fontSize: '13px',
    color: theme.palette.grey[500]
  } as SxProps,

  packageStatValue: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps
}

export default styles
